import { TablePagination } from '@mui/material';
import React from 'react';
import { useCommonDataTableUiTranslation } from '../../hooks';
import { defaultRowsPerPage, defaultRowsPerPageOptions } from '../types';
export const TablePaginationContent = ({ filteredRowCount, page, rowsPerPage, rowsPerPageOptions, onPageChange, onRowsPerPagePageChange, }) => {
    const { t } = useCommonDataTableUiTranslation();
    if (filteredRowCount != null && page != null && rowsPerPage != null) {
        return (React.createElement(TablePagination, { role: 'navigation', "aria-label": t('paginationNavigation'), component: 'div', page: page, count: filteredRowCount, rowsPerPage: rowsPerPage !== null && rowsPerPage !== void 0 ? rowsPerPage : defaultRowsPerPage, rowsPerPageOptions: rowsPerPageOptions !== null && rowsPerPageOptions !== void 0 ? rowsPerPageOptions : defaultRowsPerPageOptions, onPageChange: (event, page) => {
                if (onPageChange) {
                    onPageChange(page);
                }
            }, onRowsPerPageChange: (event) => {
                if (onRowsPerPagePageChange) {
                    onRowsPerPagePageChange(parseInt(event.target.value, 10));
                }
            } }));
    }
    else {
        return null;
    }
};
